/*
 * Copyright (C) 2018 - present by OpenGamma Inc. and the OpenGamma group of companies
 *
 * Please see distribution for license.
 */

import { Component, Input, EventEmitter, Output, TemplateRef } from '@angular/core';
import { Size, Theme } from 'app/shared/models';

@Component({
  selector: 'og-input-details-list',
  templateUrl: './input-details-list.component.html',
  styleUrls: ['./input-details-list.component.scss'],
  standalone: false
})
export class InputDetailsListComponent<T> {
  /** The title to use for the details list */
  @Input() title: string;
  /** The list of entries to display */
  @Input() list: T[] = [];
  /** Defines if the list entries are being loaded */
  @Input() loading: boolean;
  /** Defines the custom theme to be used */
  @Input() theme: Theme = 'accent';
  /** Defines the custom size to be used */
  @Input() size: Size = 'medium';
  /** Defines if existing items can be deleted */
  @Input() canDeleteItems = true;
  /** Defines if new items can be added */
  @Input() canAddItems = true;
  /** The per-item template to use */
  @Input() itemTemplate?: TemplateRef<T>;
  /** Emits list changes on insertion and deletion */
  @Output() listChange = new EventEmitter<T[]>();

  newListEntry: T;
  showInputTemplate = false;

  triggerSave(): void {
    this.listChange.next(this.list.concat(this.newListEntry));
    this.showInputTemplate = false;
  }

  propagateListChange(updatedList: T[]): void {
    this.listChange.next(updatedList);
  }
}
